// "Keep talking" nudge card. Positioned by its parent (over the bottom half of the
// number tiles). Throbs via background colour (bg-throb) — stays opaque, never
// semi-transparent.
export const KeepTalkingModal = () => (
  <div className="bg-throb max-w-xs rounded-2xl bg-[#c182ac] px-6 py-6 text-center text-white shadow-2xl">
    <p className="text-lg font-semibold">Keep talking to reveal clues</p>
    <p className="mt-1 text-sm opacity-90">We want to hear your thinking!</p>
  </div>
)
